import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import {
  Backdrop,
  ModalContainer,
  Header,
  Title,
  CloseButton,
  Body,
  Footer,
} from "./Modal.styles";

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  width,
  height,
  maxWidth,
  maxHeight,
}) {
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <Backdrop onClick={onClose}>
      <ModalContainer
        onClick={(e) => e.stopPropagation()}
        width={width}
        height={height}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
      >
        <Header>
          <Title>{title}</Title>
          <CloseButton onClick={onClose}>×</CloseButton>
        </Header>

        <Body>{children}</Body>

        {footer && <Footer>{footer}</Footer>}
      </ModalContainer>
    </Backdrop>,
    document.body
  );
}
